import React from 'react';
import { API } from 'aws-amplify';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { MdDownload } from 'react-icons/md';

import RenderIf from '../../../../renderIf';
import { toast } from 'react-toastify';
import { t } from 'i18next';

const File = ({ question, downloadOnly }) => {
    const [chosenVal] = React.useState(question?.chosenOptions ? question.chosenOptions : []);
    const [downloadURL, setDownloadURL] = React.useState();
    const [isDownloading, setDownloading] = React.useState(false);

    const downloadRef = React.useRef();

    const getDownloadURL = async () => {
        try {
            const _fileURL = await API.get('ShipyardAPI', `/application/docs/${question?.docData?.[0]?.FileID}`);

            setDownloadURL(_fileURL.downloadURL);
        } catch (e) {
            toast.error(t('General.AjaxError'));
        }
    };

    const handleClick = async () => {
        setDownloading(true);
        setTimeout(() => setDownloading(false), 10000);

        getDownloadURL();
    };

    React.useEffect(() => {
        if (downloadURL) {
            downloadRef?.current?.click();

            setDownloadURL();
        }
    }, [downloadURL]);

    return (
        <>
            <RenderIf isTrue={chosenVal.length === 0}>
                <Button
                    component="label"
                    variant="contained"
                    disabled={downloadOnly}
                >
                    Upload File
                    <input
                        hidden
                        type="file"
                    />
                </Button>
            </RenderIf>

            <RenderIf isTrue={chosenVal.length > 0}>
                <Box
                    sx={{
                        display: 'flex',
                        gap: (theme) => theme.spacing(2),
                    }}
                >
                    <Typography>{question?.docData?.[0]?.FileName}</Typography>

                    <a
                        hidden
                        href={downloadURL}
                        download={question?.docData?.[0]?.FileName}
                        ref={downloadRef}
                    >
                        {question?.docData?.[0]?.FileName || 'Download File'}
                    </a>

                    <Button
                        variant="outlined"
                        disabled={isDownloading}
                        onClick={handleClick}
                    >
                        <MdDownload />
                    </Button>

                    <RenderIf isTrue={isDownloading}>
                        <Box
                            sx={{
                                height: '2rem',
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    </RenderIf>
                </Box>
            </RenderIf>
        </>
    );
};

export default File;
